var React = require('react');

function Container (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"16","y":"16","width":"256","height":"96","fill":"#D8D8D8","key":1}),React.createElement("rect",{"x":"16","y":"128","width":"256","height":"55","fill":"#D8D8D8","key":2})]);
}

Container.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Container;

Container.default = Container;
